import {BasicEntity} from '../../framework/message/BasicEntity';

export class AbstractAccessGrant extends BasicEntity {
doBatch: boolean | null;
doCreate: boolean | null;
doDelete: boolean | null;
doNone: boolean | null;
doRead: boolean | null;
doUpdate: boolean | null;
featureCode: string;
visionCode: string;
}

